import classNames from "classnames"

import { useClientContext } from "layouts/application-group"
import styles from "./client-result-box.module.scss"
import { useEffect, useState } from "react"
import request from "request"
import { calculateRisk, RiskDivision } from "utils/calculateRisk"

const ClientResultBox = () => {
  const { application } = useClientContext()

  const [riskDecision, setRiskDecision] = useState<{
    result: "Rejected" | "Approved" | ""
    text: RiskDivision | ""
    value: number
  }>({
    result: "",
    text: "",
    value: 0,
  })

  const risks = application.risk_log?.risks

  useEffect(() => {
    if (!risks) return

    setRiskDecision(calculateRisk(risks.total_risk))
  }, [risks?.total_risk])

  const getOCRStatus = () => {
    if (!application.ocr_log) return "File not provided"
    return "File provided"
  }

  const getScoringStatus = () => {
    if (application?.scoring_log?.is_approved === null) return "No decision"
    if (application?.scoring_log?.is_approved === false) return "Rejected"
    return "Approved"
  }

  const getOIRStatus = () => {
    if (application?.oir_log === null) return "No decision"
    if (application?.oir_log?.is_approved === false) return "Rejected"
    return "Approved"
  }

  const getDBRStatus = () => {
    if (application.scoring_log?.dbr_is_approved === null) return "No decision"
    if (application.scoring_log?.dbr_is_approved === false) return "Rejected"
    return "Approved"
  }

  const getStopFactorsStatus = () => {
    if (application.scoring_log?.stop_factors_is_approved === null)
      return "No decision"
    if (application.scoring_log?.stop_factors_is_approved === false)
      return "Rejected"
    return "Approved"
  }

  const riskFactorsStyles = classNames(styles.value, {
    [styles.red]: application.risk_log?.is_approved === false,
    [styles.green]: application.risk_log?.is_approved,
  })

  const ocrClassName = classNames(styles.value, {
    [styles.red]: !application.ocr_log,
    [styles.green]: application.ocr_log,
  })

  const scoringClassName = classNames(
    styles.value,
    application.scoring_log?.is_approved !== null && {
      [styles.red]: !application.scoring_log?.is_approved,
      [styles.green]: application.scoring_log?.is_approved,
    },
  )
  const OirClassName = classNames(
    styles.value,
    application.oir_log !== null && {
      [styles.red]: !application.oir_log?.is_approved,
      [styles.green]: application.oir_log?.is_approved,
    },
  )

  const dbrClassName = classNames(
    styles.value,
    application.scoring_log?.dbr_is_approved !== null && {
      [styles.red]: !application.scoring_log?.dbr_is_approved,
      [styles.green]: application.scoring_log?.dbr_is_approved,
    },
  )
  const stopFactorsClassName = classNames(
    styles.value,
    application.scoring_log?.stop_factors_is_approved !== null && {
      [styles.red]: !application.scoring_log?.stop_factors_is_approved,
      [styles.green]: application.scoring_log?.stop_factors_is_approved,
    },
  )

  return (
    <div className={styles.result_box}>
      <div className={styles.title}>
        Individual status (ID {application.id})
      </div>
      <div className={styles.item}>
        <div className={styles.key}>OCR</div>
        <div className={ocrClassName}>{getOCRStatus()}</div>
      </div>

      <div className={styles.item}>
        <div className={styles.key}>Risk factors</div>
        <div className={riskFactorsStyles}>
          <span>{`${application?.risk_log?.is_approved === null || application?.risk_log?.is_approved === undefined ? "No decision" : application.risk_log.is_approved ? "Approved" : "Not Approved"} (${application?.risk_log?.risks?.high_risk_count ?? 0})`}</span>
        </div>
      </div>

      <div className={styles.item}>
        <div className={styles.key}>Over Indebtedness Ratio </div>
        <div className={OirClassName}>
          <span>{getOIRStatus()}</span>
          <span>
            {!application.oir_log?.value
              ? `(0%)`
              : `(${Math.round(Number(application.oir_log?.value) * 100)}%)`}
          </span>
        </div>
      </div>
      <div className={styles.item}>
        <div className={styles.key}>Scoring</div>
        <div className={scoringClassName}>
          {getScoringStatus()}
          {application.scoring_log?.prediction &&
            ` (${application.scoring_log.prediction}%)`}
        </div>
      </div>
      <div className={styles.item}>
        <div className={styles.key}>DBR</div>
        <div className={dbrClassName}>{getDBRStatus()}</div>
      </div>
      <div className={styles.item}>
        <div className={styles.key}>Stop factors</div>
        <div className={stopFactorsClassName}>{getStopFactorsStatus()}</div>
      </div>
    </div>
  )
}

export default ClientResultBox
